import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=6b35b5de&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=6b35b5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35b5de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b35b5de')) {
      api.createRecord('6b35b5de', component.options)
    } else {
      api.reload('6b35b5de', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=6b35b5de&scoped=true&", function () {
      api.rerender('6b35b5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XIXAN5488smZ/JS/comp/PopupDialog.vue"
export default component.exports